import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import EmassDashboard from '../../common/buttons/emassDash';
import { useNavigate } from 'react-router-dom';

export default function AoOversight() {

  const baseRoute = process.env.REACT_APP_BASE_RpmOUTE || '/';
  const imgRoute = 'images/analytics/ao-oversight.png';
  const route = baseRoute + imgRoute;
  const navigate = useNavigate();
  const handleResponse = (() => {
    navigate('/aoOversightDetails')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        AO Oversight View
      </Typography>
      <EmassDashboard></EmassDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="AO Oversight Info"
          src={route}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-10px', marginBottom: '-50px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ 
          fontSize: '0.7rem',
          marginRight: "630px", 
          marginTop: '-247px',
          mb: '200px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        system_100
      </Button>
      </Box>
    </Container>
  );
};